<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ search }}<br /><br /> -->
        <!-- {{ item }} 
        {{ mapper_days }} -->
        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable text-left">
                <b-card-body class="py-0">
                    <b-tabs class="gridtabs">
                        <b-tab :active="true">
                            <template #title>
                                <div class="badgecontainer pr-5">
                                    <i :class="options.icon" class="text-primary mr-1"></i>
                                    {{ item.name }}
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                    }}&gt;</span>
                                </div>
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Code" label-for="code" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.code" placeholder="Enter code"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.code = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Name" label-for="name" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.name" placeholder="Enter name"
                                                    size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.name = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Category" label-for="category" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.category"
                                                    placeholder="Enter category" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.category = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Enabled" label-for="enabled" label-cols="12">
                                            <b-form-radio-group id="enabled" v-model="item.enabled" :options="[
                                                { text: 'Enabled', value: '1' },
                                                { text: 'Disabled', value: '0' },
                                            ]" buttons button-variant="outline-success" size="sm"
                                                name="radio-btn-outline"></b-form-radio-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>

                                <b-row align-v="end" class="nopadding my-1 mt-3 background-transparent" no-gutters>
                                    <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                        Settings
                                    </b-col>
                                </b-row>

                                <b-row>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group :disabled="readonly" label-cols="12" label="Start At"
                                            label-size="sm">
                                            <b-input-group>
                                                <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                    v-model="mapper_start_at" :disabled="readonly" :opens="'right'"
                                                    :single-date-picker="'single'" :locale-data="{
                                                        direction: 'ltr',
                                                        format: 'dd/mm/yyyy',
                                                        daysOfWeek: [
                                                            'Sun',
                                                            'Mon',
                                                            'Tue',
                                                            'Wed',
                                                            'Thu',
                                                            'Fri',
                                                            'Sat',
                                                        ],
                                                        monthNames: [
                                                            'January',
                                                            'February',
                                                            'March',
                                                            'April',
                                                            'May',
                                                            'June',
                                                            'July',
                                                            'August',
                                                            'September',
                                                            'October',
                                                            'November',
                                                            'December',
                                                        ],
                                                        firstDay: 1,
                                                    }" :showDropdowns="true" :ranges="false" :linkedCalendars="true"
                                                    :timePicker="false" :timePicker24Hour="false"
                                                    :time-picker-increment="1">
                                                </daterangepicker>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                        @click="mapper_start_at = {
                                                            startDate: null,
                                                            endDate: null,
                                                        }">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" lg="4" xl="3">
                                        <b-form-group label="At" label-for="at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-timepicker size="sm" v-model="item.at" button-only
                                                        label-help="" hide-header
                                                        :disabled="readonly"></b-form-timepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.at" type="text"
                                                    placeholder="HH:MM" autocomplete="off"
                                                    :disabled="readonly"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                        @click="item.at = null">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Repeat Every (min)" label-for="repeat" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.repeat"
                                                    placeholder="Enter repeat" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.repeat = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group :disabled="readonly" label-cols="12" label="End At ( Expiry )"
                                            label-size="sm">
                                            <b-input-group>
                                                <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                    v-model="mapper_end_at" :disabled="readonly" :opens="'right'"
                                                    :single-date-picker="'single'" :locale-data="{
                                                        direction: 'ltr',
                                                        format: 'dd/mm/yyyy',
                                                        daysOfWeek: [
                                                            'Sun',
                                                            'Mon',
                                                            'Tue',
                                                            'Wed',
                                                            'Thu',
                                                            'Fri',
                                                            'Sat',
                                                        ],
                                                        monthNames: [
                                                            'January',
                                                            'February',
                                                            'March',
                                                            'April',
                                                            'May',
                                                            'June',
                                                            'July',
                                                            'August',
                                                            'September',
                                                            'October',
                                                            'November',
                                                            'December',
                                                        ],
                                                        firstDay: 1,
                                                    }" :showDropdowns="true" :ranges="false" :linkedCalendars="true"
                                                    :timePicker="true" :timePicker24Hour="true"
                                                    :time-picker-increment="1">
                                                </daterangepicker>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                        @click="mapper_end_at = {
                                                            startDate: null,
                                                            endDate: null,
                                                        }">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Frequency" label-for="frequency" label-cols="12"
                                            label-size="sm">
                                            <treeselect v-model="frequency" :clearable="false"
                                                :options="options_frequency" :disabled="false" @input="changeFrequency">
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <!-- item {{ item }} / mapper {{ mapper_days }} -->
                                    <b-col cols="12" sm="6" v-show="frequency == 'daily'">

                                        <b-form-group label="Days Of Operation" label-for="monthdays" label-cols="12"
                                            label-size="sm">
                                            <treeselect v-model="mapper_days" :clearable="false" :multiple="true"
                                                :options="[{ id: '1', label: 'Every day' }]" :disabled="true">
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" v-show="frequency == 'weekday'">
                                        <b-form-group label="Days Of Operation" label-for="weekdays" label-cols="12"
                                            label-size="sm">
                                            <treeselect v-model="mapper_days" :clearable="true" :multiple="true"
                                                :options="options_weekdays" :disabled="false">
                                            </treeselect>

                                        </b-form-group>
                                    </b-col>


                                    <b-col cols="12" sm="6" v-show="frequency == 'monthly'">
                                        <b-form-group label="Days Of Operation" label-for="monthdays" label-cols="12"
                                            label-size="sm">
                                            <treeselect v-model="mapper_days" :clearable="true" :multiple="true"
                                                :options="options_monthdays" :disabled="false">
                                            </treeselect>


                                        </b-form-group>
                                    </b-col>

                                    <!-- 
                                    <b-col cols="12" sm="6" md="4" lg="4" xl="3" v-show="item.frequency == 'weekday'">
                                        <b-form-group label="Days Of Operation" label-for="days" label-cols="12">
                                            <b-input-group>
                                                <b-form-checkbox-group v-model="item.days" :options="[
                                                    { text: 'Mo', value: 1 },
                                                    { text: 'Tu', value: 2 },
                                                    { text: 'We', value: 3 },
                                                    { text: 'Th', value: 4 },
                                                    { text: 'Fr', value: 5 },
                                                    { text: 'Sa', value: 6 },
                                                    { text: 'Su', value: 0 },
                                                ]" buttons button-variant="outline-success" size="sm"
                                                    name="radio-btn-outline" class="dayssmall"></b-form-checkbox-group>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.days = []">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col> -->

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Priority" label-for="priority" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.priority"
                                                    placeholder="Enter priority" size="sm"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.priority = ''">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>



                                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Mode" label-for="runnow" label-cols="12">
                                            <b-form-radio-group id="runnow" v-model="item.runnow" :options="[
                                                { text: 'Run Now', value: '1' },
                                                { text: 'On Schedule', value: '0' },
                                            ]" buttons button-variant="outline-success" size="sm"
                                                name="radio-btn-outline"></b-form-radio-group>
                                        </b-form-group>
                                    </b-col> -->

                                </b-row>

                                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                                    <b-col cols="12" class="text-left mt-n2 divider ">
                                        <div :class="JSONShow == 'edit' ? 'text-orange' : 'text-primary'"
                                            class="inline mr-4 hover-pointer" @click="JSONShow = 'edit'">JSON Arguments
                                        </div>
                                        <div :class="JSONShow == 'view' ? 'text-orange' : 'text-primary'"
                                            class="hover-pointer" @click="JSONShow = 'view'">JSON View</div>
                                    </b-col>
                                </b-row>

                                <b-row align-v="center" v-if="JSONShow == 'edit'">
                                    <b-col cols="12">
                                        <b-form-group label="Config" label-for="data" label-cols="12">
                                            <b-form-textarea id="data" v-model="item.data" placeholder="Data" rows="4"
                                                class="smalltextarea consolas font-14px"
                                                :disabled="readonly"></b-form-textarea>
                                        </b-form-group>

                                        <b-alert v-if="JSONData.length > 0" :show="JSONData.length > 0"
                                            :variant="JSONData.includes('JSON.parse') ? 'danger' : 'primary'"
                                            class="consolas font-14px">

                                            <b-row align-v="center" no-gutters>
                                                <b-col cols="auto mr-3">
                                                    <i class="fa fa-2x"
                                                        :class="JSONData.includes('JSON.parse') ? 'fa-exclamation-circle' : 'fa-check-circle'"></i>
                                                </b-col>
                                                <b-col>
                                                    <span
                                                        v-html="JSONData.includes('JSON.parse') ? 'JSON arguments did not parse sucessfully.' : 'JSON arguments parsed sucessfully.'"></span>
                                                </b-col>
                                            </b-row>

                                        </b-alert>
                                    </b-col>
                                </b-row>

                                <b-row v-if="JSONShow == 'view'">
                                    <b-col cols="12">
                                        <b-form-group label="Config" label-for="data" label-cols="12">
                                            <vue-json-pretty :deep="1" :data="JSONData">
                                            </vue-json-pretty>
                                        </b-form-group>
                                    </b-col>
                                </b-row>


                                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                                    <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                        Checked
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="6">
                                        <b-form-group label="Last Message" label-for="lastmessage" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.lastmessage"
                                                    placeholder="Enter last message" size="sm"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.lastmessage = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label-cols="12" label="Last At" label-size="sm">
                                            <b-input-group>
                                                <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                    v-model="mapper_last_at" :disabled="true" :opens="'right'"
                                                    :single-date-picker="'single'" :locale-data="{
                                                        direction: 'ltr',
                                                        format: 'dd/mm/yyyy HH:MM',
                                                        daysOfWeek: [
                                                            'Sun',
                                                            'Mon',
                                                            'Tue',
                                                            'Wed',
                                                            'Thu',
                                                            'Fri',
                                                            'Sat',
                                                        ],
                                                        monthNames: [
                                                            'January',
                                                            'February',
                                                            'March',
                                                            'April',
                                                            'May',
                                                            'June',
                                                            'July',
                                                            'August',
                                                            'September',
                                                            'October',
                                                            'November',
                                                            'December',
                                                        ],
                                                        firstDay: 1,
                                                    }" :showDropdowns="true" :ranges="false" :linkedCalendars="true"
                                                    :timePicker="true" :timePicker24Hour="true"
                                                    :time-picker-increment="1">
                                                </daterangepicker>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" :disabled="false"
                                                        @click="item.last_at = ''; mapper_last_at = {
                                                            startDate: null,
                                                            endDate: null,
                                                        }">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">

                                        <b-form-group label="State Now" label-for="state" label-cols="12">
                                            <b-form-radio-group :disabled="false" id="state" v-model="item.running"
                                                :options="[
                                                    { text: 'Running', value: '1' },
                                                    { text: 'Idle', value: '0' },
                                                ]" buttons button-variant="outline-success" size="sm"
                                                name="radio-btn-outline"></b-form-radio-group>
                                        </b-form-group>

                                    </b-col>
                                </b-row>

                            </p>
                        </b-tab>
                        <b-tab v-if="idselected">
                            <template #title>
                                <i class="fa fa-history text-primary mr-1"></i> Audit
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="ID" label-for="id" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                    :disabled="true"></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_at = null" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_by = ''" :disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab>
                    </b-tabs>
                </b-card-body>
                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <b-col cols="auto" class="text-left mr-3">
                            <b-button squared size="sm" variant="primary" @click="saveit"
                                v-if="user.permissions.includes('setup_tasksat.admin')">
                                <i class="fa fa-check"></i>
                                Save It
                            </b-button>
                        </b-col>
                        <b-col class="text-left my-auto">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                                <i class="fa fa-chevron-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import SshPre from "simple-syntax-highlighter";
import "simple-syntax-highlighter/dist/sshpre.css";

export default {
    name: "Tasks",
    components: {
        VueJsonPretty, SshPre
    },
    async mounted() {
        await this.tasks_load()
    },
    data() {
        return {
            busy: false,
            readonly: false,
            JSONShow: 'edit',
            frequency: "daily",
            mapper_days: ['1'],
            mapper_start_at: {
                startDate: null,
                endDate: null,
            },
            mapper_end_at: {
                startDate: null,
                endDate: null,
            },
            mapper_last_at: {
                startDate: null,
                endDate: null,
            },
            options_frequency: [
                { id: "daily", label: "Daily" },
                { id: "weekday", label: "Weekday" },
                { id: "monthly", label: "Monthly" },
            ],
            options_weekdays: [
                { id: "1", label: "Mo" },
                { id: "2", label: "Tu" },
                { id: "3", label: "We" },
                { id: "4", label: "Th" },
                { id: "5", label: "Fr" },
                { id: "6", label: "Sa" },
                { id: "0", label: "Su" },
            ],
            options_monthdays: [
                { id: "1", label: "1" },
                { id: "2", label: "2" },
                { id: "3", label: "3" },
                { id: "4", label: "4" },
                { id: "5", label: "5" },
                { id: "6", label: "6" },
                { id: "7", label: "7" },
                { id: "8", label: "8" },
                { id: "9", label: "9" },
                { id: "10", label: "10" },
                { id: "11", label: "11" },
                { id: "12", label: "12" },
                { id: "13", label: "13" },
                { id: "14", label: "14" },
                { id: "15", label: "15" },
                { id: "16", label: "16" },
                { id: "17", label: "17" },
                { id: "18", label: "18" },
                { id: "19", label: "19" },
                { id: "20", label: "20" },
                { id: "21", label: "21" },
                { id: "22", label: "22" },
                { id: "23", label: "23" },
                { id: "24", label: "24" },
                { id: "25", label: "25" },
                { id: "26", label: "26" },
                { id: "27", label: "27" },
                { id: "28", label: "28" },
                { id: "29", label: "29" },
                { id: "30", label: "30" },
                { id: "31", label: "31" },
                { id: "last", label: "Last" },
            ],
            item: {},
            options: {
                title: "Setup Tasks",
                icon: "fa fa-clock-o",
            },
        };
    },
    watch: {
        mapper_start_at: {
            async handler(newVal, oldVal) {
                if (newVal.startDate) {
                    this.item.start_at = this.$moment(newVal.startDate).valueOf().toString()
                } else {
                    this.item.start_at = ''
                }
            }
        },
        mapper_end_at: {
            async handler(newVal, oldVal) {
                if (newVal.startDate) {
                    this.item.end_at = this.$moment(newVal.startDate).valueOf().toString()
                } else {
                    this.item.end_at = ''
                }
            }
        },
        mapper_last_at: {
            async handler(newVal, oldVal) {
                if (newVal.startDate) {
                    this.item.last_at = this.$moment(newVal.startDate).valueOf().toString()
                } else {
                    this.item.last_at = ''
                }
            }
        },
        mapper_days: {
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.item.days = newVal
                } else {
                    this.item.days = ''
                }
            }
        },
    },
    computed: {
        JSONData() {
            let result = ""
            try {
                result = JSON.parse(this.item.data)
            } catch (error) {
                result = error.message
            }
            return result
        }
    },
    methods: {
        changeFrequency() {
            if (this.frequency != this.item.frequency) {
                switch (this.frequency) {
                    case "daily":
                        this.mapper_days = ['1']
                        break;
                    case "weekday":
                        this.mapper_days = ['1', '2', '3', '4', '5']
                        break;
                    case "monthly":
                        this.mapper_days = ['1']
                        break;
                }
            }
        },
        async tasks_load() {

            this.busy = true

            if (this.idselected) {
                let variables = {
                    id: this.idselected,
                };
                console.log("variables", variables);
                try {
                    const response = await this.$apollo.query({
                        query: gql`
                        query setup_tasksat($id: String) {
                            setup_tasksat(id: $id) {
                                id
                                code
                                name
                                category
                                start_at
                                end_at
                                days
                                frequency
                                at
                                priority
                                repeat
                                running
                                request
                                last_at
                                lastmessage
                                enabled
                                data
                                rows
                                updated_at
                                updated_by
                                created_at
                                created_by
                            }
                        }
            `,
                        variables,
                    });

                    if (response.data.setup_tasksat.length > 0) {
                        this.item = response.data.setup_tasksat[0];

                        if (this.item.start_at) {
                            let v = this.$moment.unix(this.item.start_at * 0.001).utc(false).format("YYYY-MM-DD")
                            this.mapper_start_at = { startDate: v, endDate: v }
                        }

                        if (this.item.end_at) {
                            let v = this.$moment.unix(this.item.end_at * 0.001).utc(false).format("YYYY-MM-DD")
                            this.mapper_end_at = { startDate: v, endDate: v }
                        }

                        if (this.item.last_at) {
                            let v = this.$moment.unix(this.item.last_at * 0.001).utc(false).format("YYYY-MM-DD HH:mm")
                            this.mapper_last_at = { startDate: v, endDate: v }
                        }

                        if (this.item.days) {
                            // BE CAREFUL WITH LAST
                            let v = this.item.days.split('last').join('-1')
                            v = JSON.parse(v).map(String)
                            this.mapper_days = v.map(x => x.replace('-1', 'last'))
                        }

                        this.frequency = this.item.frequency

                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                this.mapper_days = ['1']
                this.frequency = "daily"
                this.item = {
                    name: 'New Task',
                    category: 'REPORTS',
                    frequency: 'daily',
                    at: '09:00',
                    repeat: '0',
                    days: '[1]',
                    enabled: '0',
                    running: '0',
                    priority: '0'
                }
            }
            this.busy = false;
        },
        async saveit() {
            this.busy = true;

            let variables = { rows: [this.cleanit(this.item)] };
            variables.rows[0].frequency = this.frequency
            variables.rows[0].days = JSON.stringify(variables.rows[0].days)
            if (this.config.action == "copy") {
                variables.rows[0].id = null;
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation setup_tasksat_save(
                            $rows: [setup_tasksat_input]
                        ) {
                            setup_tasksat_save(rows: $rows) {
                                id
                                code
                                name
                                category
                                start_at
                                end_at
                                days
                                frequency
                                at
                                priority
                                repeat
                                running
                                request
                                last_at
                                lastmessage
                                enabled
                                rows
                                updated_at
                                updated_by
                                created_at
                                created_by                   
                            }
                        }
                    `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },
    },
};
</script>

<style>
.ssh-pre__content {
    color: #3cb450;
}

.ssh-pre .quote {
    color: #0bc;
}

.ssh-pre[data-type="xml"] .tag-name {
    color: #c6d;
}

.vjs-tree__node .vjs-key {
    width: auto;
}
</style>